import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import { useState } from "react";
import { Snackbar, Alert, Icon, IconButton, InputAdornment } from "@mui/material";

function PasswordField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");
  // console.log(options);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <MDBox>
      <MDInput
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        label={displayName}
        type={showPassword ? "text" : "password"}
        fullWidth
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword(!showPassword)}>
                <Icon>{!showPassword ? "visibility" : "visibility_off"}</Icon>
              </IconButton>
            </InputAdornment>
          ),
        }}
        onBlur={(e) => {
          const entryValue = e.target.value;
          console.log(options);

          if (typeof options.min_length !== "undefined") {
            if (entryValue.length < options.min_length) {
              e.target.value = null;
              setErrMsg(`${displayName} must be atleast ${options.min_length} long`);
              showFieldError(true);
              return;
            }
          }

          if (typeof options.enable_strength_test !== "undefined") {
            if (options.enable_strength_test === "true") {
              let point = 0;
              const arrayTest = [/[0-9]/, /[a-z]/, /[A-Z]/, /[^0-9a-zA-Z]/];
              arrayTest.forEach((item) => {
                if (item.test(entryValue)) {
                  point += 1;
                }
              });
              if (point < 4) {
                e.target.value = null;
                setErrMsg(
                  `${displayName} is too weak. Must contain at least one number and lower and upper case letters`
                );
                showFieldError(true);
              }
            }
          }
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </MDBox>
  );
}

// Typechecking props of the Transaction
PasswordField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

PasswordField.defaultProps = {
  options: null,
};

export default PasswordField;
